import script from "./AppointmentchangeView.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppointmentchangeView.vue?vue&type=script&lang=ts&setup=true"

import "./AppointmentchangeView.vue?vue&type=style&index=0&id=5bd34956&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bd34956"]])

export default __exports__